import Overlay from 'Prototype/UI/Overlay';
import Element from '../../../../Prototype/UI/Element';
import GameObject from 'GameObject/GameObject';
import TransformComponent from 'Component/Transform';
import { StartAnimation, StartAnimationClip } from 'System/Animation/AnimationHelper';
import { PlaySound } from 'System/Audio/AudioHelper';
import Renderable from 'Component/Renderable';
import { AnimationClipEvent } from 'System/Animation/AnimationClip';
import { SeasonPassPurchaseComplete } from 'Layouts/Quests/SeasonPass/SeasonPassPurchaseComplete';
import Armature from 'Prototype/Armature';
import { Point } from 'pixi.js';
import { DragonbonesDefault } from 'System/Animation/Clip';

export class SeasonPassPurchaseCompletePopup extends Element {
    private overlay: Overlay;
    private layout: any;
    private purchaseArmature: Armature;

    public create(): void {
        super.create({
            type: 'group',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
            },
        });

        this.overlay = GameObject.Instantiate(Overlay, {
            name: 'overlay',
            preventInteraction: true,
            anchors: [0, 0, 0, 0],
            alpha: 0.9,
            color: [0, 0, 0, 225],
        });
        this.addChild(this.overlay);

        this.layout = new SeasonPassPurchaseComplete();
        this.addChild(this.layout.root);

        this.layout.root.getComponent(TransformComponent).y -= this.container.height / 4;

        this.purchaseArmature = GameObject.Instantiate(Armature, {
            dragonbonesName: 'premium_unlock',
            armatureName: 'Armature',
            alpha: 1,
            playOnStart: false,
            position: new Point(0, 0),
        });
        this.layout.AnimationContainer.addChild(this.purchaseArmature);

        this.show();
    }

    public show() {
        this.getComponent(Renderable).visible = false;
        this.overlay.getComponent(Renderable).alpha = 0;

        StartAnimation(this.overlay, 'OverlayFadeIn');
        StartAnimation(this, 'Alpha', {
            startAlpha: 0,
            endAlpha: 1,
            duration: 500
        }).once(AnimationClipEvent.COMPLETE, () => {
            StartAnimation(this.layout.PurchaseCompleteText, 'UIPopIn');
            PlaySound('Wheel_Reward');
            StartAnimationClip(
                new DragonbonesDefault(this.purchaseArmature, {
                    playTimes: 1,
                    animationName: 'premium_unlock',
                }).once(AnimationClipEvent.COMPLETE, () => {
                    this.destroy();
                })
            );
        });
    }

    public destroy(): void {
        StartAnimation(this.overlay, 'OverlayFadeOut')
        StartAnimation(this, 'Alpha', {
            startAlpha: 1,
            endAlpha: 0,
            duration: 500
        }).once(AnimationClipEvent.COMPLETE, () => {
            super.destroy();
        });
    }
}
